import { Component } from '@angular/core';
import { Toast } from 'ngx-toastr';

@Component({
    selector: 'app-toast',
    imports: [],
    templateUrl: './toast.component.html',
    styleUrl: './toast.component.scss',
    host: {
        'animate.enter': 'animate-pink-in',
        'animate.leave': 'animate-pink-out',
    }
})
export class ToastComponent extends Toast {

}
